import Auth from './AuthContainer'

export default Auth



// WEBPACK FOOTER //
// ./src/components/Auth/index.js